import React, { Component } from 'react';
import {isEqual} from 'lodash'

class LayoutGridBackground extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(nextProps, this.props)) {
      // console.log('no need to update')
      return false
    }
    return true
  }
  render() {
    console.log('layout-guide-rendering')
    let bWidth = this.props.width / this.props.cols
    let bHeight = this.props.rowHeight
    // let rows = Math.round(this.props.height / this.props.rowHeight)
    // let blocks = [...Array(rows)].map(r => [...Array(this.props.cols)])
    // console.log(blocks)
    // let gridArray = [...]
    return(
      <div className="paper-guide-bg no-print" style={{
        width: this.props.width + 'px',
        height: this.props.height + 'px'
      }}>
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
      <defs>
        {/* <pattern id="smallGrid" width={bWidth} height={bHeight} patternUnits="userSpaceOnUse">
          <path d={`M ${bWidth} 0 L 0 0 0 ${bHeight}`}
            fill="none"
            stroke="rgba(0,100,255,0.1)"
            strokelocation='center'
            strokeWidth="1"/>
        </pattern> */}
        {/* <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
          <rect width="80" height="80" fill="url(#smallGrid)"/>
          <path d="M 80 0 L 0 0 0 80" fill="none" stroke="gray" stroke-width="1"/>
        </pattern> */}
      </defs>

      {/* PAGE CONTENT ZONE */}
      <rect width="100%" height="100%"
        stroke="rgba(0,100,255,1)"
        strokelocation='center'
        fill="url(#smallGrid)" />
      </svg>

      </div>
    )
  }
}
export default LayoutGridBackground
